/**
 * ImageBlock — mirrors aidea.templateengine/src/slides/components/ImageBlock
 * Renders an image with object-fit cover, optional position alignment.
 *
 * position: 'center' | 'top' | 'bottom'
 */
import React from "react";

/* eslint-disable react/prop-types */

const POSITION_MAP = {
  center: "center center",
  top: "center top",
  bottom: "center bottom",
};

export function ImageBlock({ src, alt, position = "center" }) {
  if (!src) return null;

  return (
    <div
      className="atomic-image-block"
      style={{
        width: "100%",
        borderRadius: "var(--surface-radius)",
        overflow: "hidden",
        background: "var(--color-bg-surface)",
      }}
    >
      <img
        src={src}
        alt={alt || ""}
        style={{
          width: "100%",
          height: "100%",
          objectFit: "cover",
          objectPosition: POSITION_MAP[position] || "center center",
          display: "block",
        }}
      />
    </div>
  );
}

export default ImageBlock;
